import React, {FC, useEffect, useRef, useState} from "react";
import {Modal} from "antd";
import closeIcon from "../../../../assets/icons/close.svg";
import './contentEditForm.scss';
import ToggleSwitch from "../../ToggleSwitch";
import {Formik, Form,Field} from "formik";
import ButtonComponent from "../../ButtonComponent";
import InputField from "../../InputField";
import {serialize} from "serializr";
import * as appRoutes from "../../../../routes/routeConstants/appRoutes";
import {withRouter, RouteComponentProps} from "react-router-dom";
import {ChapterContentModel} from "../../../../models/CourseModels/ChapterModel/chapterContent.model";
import ChapterContentService
    from "../../../../services/CourseServices/ChapterService/chapterContent.service";
import { ExamContentModel } from "../../../../models/ExamModels/ContentModel/content.model";
import { ExamContentService } from "../../../../services/ExamService/ContentService/content.service";

interface ContentEditFormProps extends RouteComponentProps{
    visible: boolean;
    setVisible: Function;
    data:any;
    refreshList: Function;
}

const ContentEditForm:FC<ContentEditFormProps> = (props) => {

    const {visible, setVisible, data, refreshList} = props;

    const formRef = useRef<any>();

    useEffect(()=>{
        setUrlParams(props.match?.params)
        setInitialValues({
            isActive: data?.isActive,
            displayTitle: data?.displayTitle || data?.title,
        })
    },[data])

    const [buttonLoading,setButtonLoading] = useState<boolean>(false);
    const [initialValues,setInitialValues] = useState<any>({})
    const [urlParams, setUrlParams] = useState<any>()
    const handleClose = () => {
        setVisible(false);
        formRef.current.resetForm(initialValues)
    }

    const handleSubmit = (values:any) => {
        setButtonLoading(true);
        if (props.location.pathname.includes("exams") && urlParams?.subjectId) {
            ExamContentService.updateExamContent(
                {
                    id: data.id,
                    contentData: {
                        title: values.displayTitle,
                        isActive:values.isActive

                    }
                },
                (response: any) => {
                    refreshList()
                    setVisible(false)
                    setButtonLoading(false)
                    formRef.current.resetForm(initialValues)
                },
                (error: any) => {
                    setButtonLoading(false)
                }
            )

        } else {
            let chapterContentData = serialize(ChapterContentModel,values);
            let jsonData = {chaptor_content:chapterContentData};
            ChapterContentService.updateChapterContent(data?.id,jsonData,
                ()=>{
                    refreshList()
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                    setButtonLoading(false)
                },
                ()=>{},
                ()=>{
                    setButtonLoading(false)
                }
            ).then()
        }
    }

    return(
        <Modal title={null}
               centered
               visible={visible}
               onCancel={handleClose}
               footer={null}
               className='board-form__modal edit__content__modal'
               closeIcon={<img src={closeIcon} alt=''/>}
        >
            <Formik initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                    innerRef={formRef}
            >{({setFieldValue,values,resetForm})=> {
                return(
                    <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <div className='board-form__header'>
                            <div className='board-form__title'>Edit Content</div>
                            <div className='board-form__toggle'>
                                <Field name="isActive" as='switch'>
                                    <ToggleSwitch checked={values.isActive}
                                                  handleChange={() => {
                                                      setFieldValue('isActive', !values.isActive)
                                                  }}
                                    />
                                </Field>
                            </div>
                        </div>

                        <div className='content__details'>
                            <img src={data?.contentLibrary?.displayPictureUrl} alt=''/>
                            <div className='content__info'>
                                {data?.contentLibrary?.contentType} - {data?.contentLibrary?.contentLength} {data?.contentLibrary?.contentType === 'video' ? 'mins' : 'pages'}
                            </div>
                            <div className='content__library__button'
                             onClick={()=>{props.history.push({
                                pathname:appRoutes.CONTENT_LIBRARY,
                                state:data?.contentLibrary?.id
                                })}}>
                                Show in content library
                            </div>
                        </div>


                        <div className="board-form__input">
                            <div className='board-form__label'>Display title</div>
                            <InputField type="text" name="displayTitle" placeholder="Class name"/>
                        </div>

                        <div className='board-form__action'>
                            <div className='board-form__button' onClick={() => {
                                handleClose();
                                resetForm({})
                            }}>
                                <ButtonComponent buttonContent='Cancel'
                                                 type='text'
                                />
                            </div>
                            <div className='board-form__button'>
                                <ButtonComponent buttonContent='Update'
                                                 type='primary'
                                                 htmlType='submit'
                                                 loading={buttonLoading}
                                />
                            </div>
                        </div>
                    </Form>
                )
            }}
            </Formik>
        </Modal>
    )
}

export default withRouter(ContentEditForm);
